module.exports = __webpack_public_path__ + "fee66e712a8a08eef5805a46892932ad.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 486
// module chunks = 0